


















































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';
import ReferralHistoryModal from 'frontend/views/referral/components/ReferralHistoryModal.vue';

@Component({
  components: { ReferralHistoryModal },
  computed: {
    ...mapGetters('notificationsDrawer', [
      'endNotificationId',
      'startNotificationId',
      'numExtra',
      'numNewNotifications',
    ]),
    ...mapState('notificationsDrawer', ['notifications']),
  },
})
export default class NotificationsDrawer extends Vue {
  @Prop(Boolean) readonly loaded!: boolean;
  public endNotificationId?: number;
  public startNotificationId?: number;
  public numExtra?: number;
  public numNewNotifications?: number;
  public notifications?: any[];
  private showReferralHistoryModal = false;

  dismissNotification(notificationId: number) {
    this.$store.dispatch('notificationsDrawer/dismissNotification', notificationId);
  }
  dismissAllNotifications() {
    this.$store.dispatch('notificationsDrawer/dismissAllNotifications');
  }

  private isReferralCreditNotification(n: any): boolean {
    return n.notification_type === 28;
  }

  private searchForReferralCreditNotificationAndUpdateLinkHandler() {
    if (!this.notifications) {
      return;
    }
    for (const n of this.notifications) {
      if (this.isReferralCreditNotification(n)) {
        const notificationElement = document.getElementById(`notification-${n.notification_id}`);
        const links = notificationElement?.getElementsByTagName('a');
        if (links?.length) {
          const link = links[0];
          link.addEventListener('click', (e: any) => {
            e.preventDefault();
            e.stopPropagation();
            this.showReferralHistoryModal = true;
          });
        }
      }
    }
  }

  private updated() {
    if (this.loaded) {
      this.searchForReferralCreditNotificationAndUpdateLinkHandler();
    }
  }
}
